module.exports = __webpack_public_path__ + "img/37_03.b045ae43.png";